import styled from "styled-components";

export const StyledSelectWrapper = styled.div`
  text-align: left;
`